import { Box, Button, Grid, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import React, { useContext } from 'react';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { Reservation } from '../../../../interfaces/bookingContext';
import dayjs from 'dayjs';
import { AppContext } from '../../../../utils/appContext';
import { useHistory } from 'react-router-dom';
import { IAccommodationMoreInfo } from '../../../../interfaces/huWebsite';

interface IBookingRecap {
  reservation: any;
  room: IAccommodationMoreInfo | undefined;
}

const BookingRecap = ({ reservation, room }: IBookingRecap) => {
  const useStyles = makeStyles()((theme) => {
    return {
      bookingDetails: {
        b: {
          alignItems: 'center',
          fontFamily: theme.typography.h1.fontFamily,
          '& svg': {
            color: '#2357D0',
            fontSize: 16,
            marginRight: 5
          }
        },
        p: {
          fontFamily: theme.typography.body1.fontFamily
        }
      },
      total: {
        b: {
          fontFamily: theme.typography.h1.fontFamily
        }
      },
      ctaManagement: {
        fontSize: 16,
        fontFamily: theme.typography.h1.fontFamily
      }
    };
  });

  const { classes } = useStyles();
  const { t } = useTranslation();
  const appContext = useContext(AppContext);
  let history = useHistory();

  let childCat = '';
  let totalChild = 0;

  if (reservation.Child) {
    reservation.Child.map((C: any, index: number) => {
      childCat = childCat + ' ' + C.value + ' ' + C.Description + ',';
      childCat.slice(0, -1);

      totalChild += Number(C.value);
    });
  }

  const howPaid = (reservation: Reservation): number => {
    let Paid = 0;
    reservation.Postings.filter((posting: any) => posting.DepartmentType === '3').map(
      (posting: any) => (Paid += parseFloat(posting.PostingPrice))
    );
    // check payment with points
    reservation.Postings.filter(
      (posting: any) => posting.DepartmentType === '1' && posting.DepartmentCode === '136'
    ).map((posting: any) => (Paid += Math.abs(parseFloat(posting.PostingPrice))));
    return Paid;
  };

  const howToPay = (reservation: Reservation): number => {
    return parseFloat(reservation.TotalStay) - howPaid(reservation);
  };

  const goToBookingPayment = () => {
    history.push(
      `/booking-management/payment?GuestArrival=${dayjs(
        reservation.GuestArrival,
        'DD.MM.YYYY'
      ).format('DD.MM.YYYY')}&GuestDeparture=${dayjs(
        reservation.GuestDeparture,
        'DD.MM.YYYY'
      ).format('DD.MM.YYYY')}&GuestNum=${reservation.GuestNum}&property=${appContext.property}`
    );
  };

  return (
    <>
      <Box className={classes.bookingDetails} mb={3}>
        <Grid item>
          <Typography variant={'h6'} component={'b'}>
            Nome Cognome
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant={'body1'} component={'p'}>
            {reservation.GuestFirstname} {reservation.GuestName}
          </Typography>
        </Grid>

        <Box mt={4} sx={{ marginTop: { xs: 2, md: 4 } }}>
          <Grid item>
            <Typography variant={'h6'} component={'b'} style={{ display: 'flex' }}>
              <CalendarMonthIcon /> Arrivo e partenza
            </Typography>
          </Grid>
          {reservation.GuestArrival && reservation.GuestDeparture && (
            <Grid item>
              <Typography variant={'body1'} component={'p'}>
                {dayjs(reservation.GuestArrival, 'DD/MM/YYYY').format('DD/MM/YYYY')} -{' '}
                {dayjs(reservation.GuestDeparture, 'DD/MM/YYYY').format('DD/MM/YYYY')}
              </Typography>
            </Grid>
          )}
        </Box>

        <Box mt={4} sx={{ marginTop: { xs: 2, md: 4 } }}>
          <Grid item>
            <Typography variant={'h6'} component={'b'} style={{ display: 'flex' }}>
              <PeopleAltOutlinedIcon /> Ospiti
            </Typography>
          </Grid>
          {reservation.NoOfAdults && (
            <Grid item>
              <Typography variant={'body1'} component={'p'}>
                {Number(reservation.NoOfAdults) + totalChild} {t('guests')}{' '}
                {reservation.Child
                  ? `(${reservation.NoOfAdults} ${t('adults')}, ${childCat.slice(0, -1)})`
                  : ''}
              </Typography>
            </Grid>
          )}
        </Box>

        <Box mt={4} sx={{ marginTop: { xs: 2, md: 4 } }}>
          <Grid item>
            <Typography variant={'h6'} component={'b'} style={{ display: 'flex' }}>
              <HomeOutlinedIcon /> Tipologia alloggio
            </Typography>
          </Grid>
          {room && (
            <Grid item>
              <Typography variant={'body1'} component={'p'}>
                {room.title}
              </Typography>
            </Grid>
          )}
        </Box>
      </Box>

      <hr style={{ border: '1px solid #F4F3EF' }} />

      <Box mt={4}>
        <Grid container direction={'row'} justifyContent={'center'} alignItems={'center'}>
          <Grid item xs={6}>
            <Typography variant={'body1'} component={'p'}>
              Importo
            </Typography>
            <Typography variant={'body1'} component={'p'}>
              Acconto pagato
            </Typography>
          </Grid>
          <Grid item xs={6} style={{ textAlign: 'right' }}>
            <Typography variant={'body1'} component={'p'}>
              € {reservation.TotalStay}
            </Typography>
            {reservation.Postings && (
              <Typography variant={'body1'} component={'p'}>
                € {howPaid(reservation)}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12}>
            <hr style={{ border: '1px solid #000000' }} />
          </Grid>

          <Grid item xs={6} className={classes.total}>
            <Typography variant={'body1'} component={'b'}>
              Importo
            </Typography>
          </Grid>
          <Grid item xs={6} className={classes.total} style={{ textAlign: 'right' }}>
            {reservation.Postings && (
              <Typography
                variant={'body1'}
                component={'b'}
                style={{
                  display: 'inline-flex',
                  borderBottom: '4px solid rgb(255, 182, 74)',
                  lineHeight: '0.4'
                }}>
                € {howToPay(reservation)}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} mt={3}>
            <Button
              color={'secondary'}
              variant={'contained'}
              fullWidth
              className={classes.ctaManagement}
              onClick={goToBookingPayment}>
              Prosegui al pagamento
            </Button>
            <Box mt={1} textAlign={'center'}>
              {reservation.RateCode && (
                <>
                  {reservation.RateCode.split('_')[2] === 'AS' ||
                    (reservation.RateCode.split('_')[2] === 'AX' &&
                      (dayjs(reservation.GuestArrival).diff(dayjs(), 'days') < 30
                        ? ''
                        : 'Il saldo è da pagare entro il ' +
                          dayjs(reservation.GuestArrival, 'DD/MM/YYYY')
                            .subtract(30, 'days')
                            .format('DD.MM.YYYY')))}
                </>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default BookingRecap;
